<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/>
  <path d="M0,0H24V24H0Z" fill="none"/><circle cx="10.5" cy="10.5" r="5.5" fill="none"/><path d="M20.75,19.34,16.46,15A7.52,7.52,0,1,0,15,16.46l4.29,4.29ZM10.5,16A5.5,5.5,0,1,1,16,10.5,5.51,5.51,0,0,1,10.5,16Z"/>
  <!-- <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/> -->
  <!-- <path :fill="color" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/> -->
</svg>
</template>

<script>
export default {
  name: 'icon-search',
// props: [ 'color', ],
};
</script>

<style lang="scss" scoped>
</style>